import { useState } from "react";

//Components
import Offense from "./Offense";
import { AppBar, Tabs, Tab, Typography, Box } from "@material-ui/core";

//Styling
import { useStyles } from "../Styles/styles";
import { withStyles } from "@material-ui/core/styles";
//Utils
import PropTypes from "prop-types";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box style={{ padding: "0px" }} p={1}>
          <Typography component={"div"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const StyledTab = withStyles(() => ({
  root: {
    color: props =>
      props.nightmode === "true"
        ? props.selected
          ? "white"
          : "#bbbbbb"
        : "inherit",
  },
}))(props => <Tab {...props} />);

const OffensesTabs = ({
  incidentOffenses,
  piss,
  incidentId,
  incidentIndex,
  incidentOriId,
  userRoles,
  disabled,
  setPopper,
  ...props
}) => {
  const classes = useStyles();
  const [offenseTab, setOffenseTab] = useState(0);

  const handleChange = (event, newValue) => {
    setOffenseTab(newValue);
  };

  return (
    <div
      style={{ border: "1px solid black", borderTop: "none" }}
      className={classes.tabsDiv}
    >
      <AppBar position="static" color="default">
        <Tabs
          value={offenseTab}
          onChange={handleChange}
          indicatorColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          {incidentOffenses.map((offense, index) => {
            return (
              <StyledTab
                nightmode={props.nightMode?.toString()}
                selected={index === offenseTab}
                key={offense.id}
                label={`Offense ${offense.id}`}
                {...a11yProps(index)}
              />
            );
          })}
        </Tabs>
      </AppBar>
      {incidentOffenses.map((offense, index) => {
        return (
          <TabPanel key={offense.id} value={offenseTab} index={index}>
            <Offense
              offense={offense}
              offenseIndex={index}
              incidentId={incidentId}
              incidentIndex={incidentIndex}
              piss={piss}
              offenseLength={incidentOffenses?.length}
              offenseTab={offenseTab}
              setOffenseTab={setOffenseTab}
              incidentOriId={incidentOriId}
              userRoles={userRoles}
              setPopper={setPopper}
              {...props}
            />
          </TabPanel>
        );
      })}
    </div>
  );
};

export default OffensesTabs;
